module.exports = __webpack_public_path__ + "static/media/SVG_forward_left_icon.a4fb6eb7.svg";